module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"gis-menu\">\n    <div class=\"gis-menu-wrapper\">\n        <ul class='gis-menu-list' name=\"menu\"></ul>\n    </div>\n    <button name=\"switcher\" class=\"gis-menu-switcher menu-switcher\" on-click=\"onMenuSwitchClick\" title=\"")
    ; __append(escapeFn( widget.collapsed ? "Развернуть" : "Свернуть" ))
    ; __append("\">\n        <span class=\"icon-list2 icon-16\"></span>\n    </button>\n    <button name=\"selected\" class=\"gis-menu-switcher filter-switcher selected-switcher\" on-click=\"onMenuSelectedClick\" title=\"Показывать только выбранные\">\n        <span class=\"icon-checkbox-checked icon-16\"></span>\n    </button>\n    <button name=\"non-selected\" class=\"gis-menu-switcher filter-switcher non-selected-switcher\" on-click=\"onMenuNonSelectedClick\" title=\"Показывать только не выбранные\">\n        <span class=\"icon-checkbox-unchecked icon-16\"></span>\n    </button>\n</div>")
  }
  return __output.join("");

}